// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shared-step-editor-header-close{cursor:pointer}.shared-step-editor-header-close,.shared-step-editor-header-close:hover{background:transparent;border:0;outline:0}.shared-step-editor-header-close__icon{height:inherit;height:15px;width:15px}.shared-step-editor-header-close__cancel{margin-right:20px}.shared-step-editor-header-close__content{font-size:15px}", ""]);
// Exports
module.exports = exports;
